/* eslint-disable */
import Konva from 'konva';
import _ from 'lodash';
import { uuid2 as uuid } from './utils';

class Rect {
  constructor(option = {}, stage) {
    this.option = option;
    this.stage = stage;
    this.build();
  }

  build() {
    this.ele = new Konva.Rect({
      id: uuid(),
      width: this.option.width,
      height: this.option.height,
      x: this.option.x,
      y: this.option.y,
      strokeWidth: 4,
      stroke:'rgba(0,0,255,1)',
      fill: this.option.mosaic ? 'rgba(0,0,255,0.4)' : '',
      draggable: true,
    });
    this.ele.on('dragend', () => {
      this.option.x = this.ele.x();
      this.option.y = this.ele.y();
      this.stage.change()
    });

    this.ele.on('click', (e) => {
      this.stage.blockClickHandler(e, this);
    });

    this.stage.editLayer.add(this.ele);
    this.layer = this.stage.editLayer;

    return this.ele;
  }
  update() {
    console.log(this.option)
    this.ele.x(this.option.x)
    this.ele.y(this.option.y)
    this.ele.width(this.option.width)
    this.ele.height(this.option.height)
    if(this.option.mosaic) {
      this.ele.fill('rgba(0,0,255,0.4)')
    } else {
      this.ele.fill('')
    }
    this.stage.change()
  }
  toObject() {
    return _.cloneDeep(this.option)
  }
}
const STATE = {
  VIEW: 'view',
  ADD: 'add',
  EDIT: 'edit',
};
export default class Stage {
  constructor(option) {
    this.option = option;
    const { container } = this.option;
    const { clientWidth, clientHeight } = container;

    this.stage = new Konva.Stage({
      container,
      width: clientWidth,
      height: clientHeight,
      draggable: false,
    });

    this.bgLayer = new Konva.Layer();
    this.editLayer = new Konva.Layer();
    this.viewLayer = new Konva.Layer();

    this.stage.add(this.bgLayer);
    this.stage.add(this.editLayer);

    this.bgLayer.draw();
    this.editLayer.draw();

    // 当前编辑状态
    this.state = 'view';
    // 背景图
    this.background = null;

    // 当前选中react
    this.curRect = null

    // 图形集合
    this.graphicList = [];


    // 键盘对应
    this.key = '';

    // 缩放和位移相关
    this.graphicPosition = { x: 0, y: 0 };
    this.graphicScale = 1;
    this.events = {
      keyboardHandler: (e) => {
        this.keyboardHandler(e);
      },
      keyboardHandlerUp: (e) => {
        this.keyboardHandlerUp(e);
      },
    };

    this.setBackground(this.option.url);
    this.initEvents();
  }

  async setBackground(url) {
    const { container } = this.option;
    const { clientWidth, clientHeight } = container;
    const p = new Promise((resolve, reject) => {
      if (!url) return;
      if (this.background) {
        const imageObj = new Image();
        imageObj.onload = () => {
          this.background.width(imageObj.width)
          this.background.height(imageObj.height)
          this.background.image(imageObj);
          // scale 大小
          const scale = Math.min(clientWidth / imageObj.width, clientHeight / imageObj.height);
          this.stage.scale({ x: scale, y: scale });
          let x = 0;
          x = (clientWidth - imageObj.width * scale) / 2;
          this.stage.x(x);
          this.bgLayer.draw();
          resolve();
        };
        imageObj.src = url;
        return;
      }
      this.background = new Konva.Image({
        draggable: false,
      });
      const imageObj = new Image();
      imageObj.onload = () => {
        console.log(imageObj.width)
        console.log(imageObj.height)
        this.background.width(imageObj.width)
        this.background.height(imageObj.height)
        // scale 大小
        const scale = Math.min(clientWidth / imageObj.width, clientHeight / imageObj.height);
        this.stage.scale({ x: scale, y: scale });
        let x = 0;
        x = (clientWidth - imageObj.width * scale) / 2;
        this.stage.x(x);
        this.background.image(imageObj);
        this.bgLayer.draw();
        resolve();
      };
      imageObj.src = url;
      this.bgLayer.add(this.background);
    });
    return p;
  }

  // 计算画布的当前坐标和缩放值
  setGraphicPosition(e) {
    const { stage } = this;
    const scaleBy = 1.05;

    e.evt.preventDefault();
    const oldScale = stage.scaleX();
    const pointer = stage.getPointerPosition();

    const mousePointTo = {
      x: (pointer.x - stage.x()) / oldScale,
      y: (pointer.y - stage.y()) / oldScale,
    };

    const newScale = e.evt.deltaY < 0 ? oldScale * scaleBy : oldScale / scaleBy;

    this.graphicPosition = {
      x: pointer.x - mousePointTo.x * newScale,
      y: pointer.y - mousePointTo.y * newScale,
    };
    this.graphicScale = newScale;
    stage.scale({ x: this.graphicScale, y: this.graphicScale });
    stage.position(this.graphicPosition);
    stage.batchDraw();
  }

  initEvents() {
    const { stage } = this;
    // 舞台滚动放大缩小
    stage.on('wheel', (e) => {
      this.setGraphicPosition(e);
    });

    stage.on('dragmove', (e) => {
    });

    stage.on('dragend', (e) => {
    });

    // 鼠标移动
    stage.on('mousemove', (e) => {
      if (this.state !== STATE.EDIT) return
      if (!this.addRect) return
      const { x, y } = this.getWorldPosition(e);
      let x0 = 0
      let y0 = 0
      if (x > this.start_x) {
        x0 = this.start_x
      } else {
        x0 = x
      }
      if (y > this.start_y) {
        y0 = this.start_y
      } else {
        y0 = y
      }
      if (this.preRect) {
        this.preRect.width(Math.abs(x - this.start_x))
        this.preRect.height(Math.abs(y - this.start_y))
        this.preRect.x(x0)
        this.preRect.y(y0)
        this.preRect.draw()
      } else {
        this.preRect = new Konva.Rect({
          width: Math.abs(x - this.start_x),
          height: Math.abs(y - this.start_y),
          x: x0,
          y: y0,
          stroke: 'red',
          dash: [10, 5],
          strokeWidth: 4,
          draggable: false,
        });
        this.editLayer.add(this.preRect)
        this.editLayer.draw()
      }
    });
    // 按下
    stage.on('mousedown', (e) => {
      if (this.state !== STATE.EDIT) return
      if (e.target.id()) {
        this.addRect = false
        return false
      } else {
        this.addRect = true
      }
      const { x, y } = this.getWorldPosition(e);
      this.start_x = x;
      this.start_y = y;
    });
    // 抬起
    stage.on('mouseup', (e) => {
      if (this.state !== STATE.EDIT) return
      if (!this.addRect) return
      if (this.preRect) {
        this.preRect.destroy()
        this.preRect = null
        this.editLayer.draw()
      }
      const { x, y } = this.getWorldPosition(e);
      console.log('抬起');
      let x0 = 0
      let y0 = 0
      if (x > this.start_x) {
        x0 = this.start_x
      } else {
        x0 = x
      }
      if (y > this.start_y) {
        y0 = this.start_y
      } else {
        y0 = y
      }
      this.addRect = false
      if (Math.abs(x - this.start_x) === 0 || Math.abs(y - this.start_y) === 0) return
      const rect = new Rect({
        width: Math.abs(x - this.start_x),
        height: Math.abs(y - this.start_y),
        x: x0,
        y: y0,
        mosaic: false,
      }, this);
      this.graphicList.push(rect)
      this.change()
      console.log('新增信息')
      console.log(rect)
      // 添加区域
      this.option.listeners.blockClickHandler(
        rect.ele,
        rect
      );
      if(this.curRect) {
        this.curRect.ele.stroke('rgba(0,0,255,1)')
      }
      this.addRect = null
      this.curRect = rect
      this.curRect.ele.stroke('red')
      console.log('新增矩形');
    });


    // 点击
    stage.on('click', (e) => {
      if(!e.target.id()) {
        this.option.listeners.blockClickHandler()
        if(this.curRect) {
          this.curRect.ele.stroke('rgba(0,0,255,1)')
        }
      }
    });

    // 右键
    stage.on('contentContextmenu', (e) => {
      e.evt.preventDefault();
      e.evt.stopPropagation();
    });

    // 键盘
    window.addEventListener('keydown', this.events.keyboardHandler);
    window.addEventListener('keyup', this.events.keyboardHandlerUp);
  }

  // 键盘事件 按下
  keyboardHandler(e) {
    this.key = e.key;
    if (e.key === 'Control') {
      this.stage.draggable(true)
    }
  }
  // 键盘事件 抬起
  keyboardHandlerUp(e) {
    this.key = '';
    this.stage.draggable(false)
  }

  // 世界坐标系
  getWorldPosition(e) {
    const { top, left } = this.option.container.getBoundingClientRect();
    const scale = this.stage.scaleX();
    const offsetX = this.stage.x();
    const offsetY = this.stage.y();
    return {
      x: (e.evt.x - offsetX - left) / scale,
      y: (e.evt.y - offsetY - top) / scale,
    };
  }

  // 元素选中
  changeTransformNodes(node) {
    if (this.prevNode && this.prevNode.graphic) {
      this.prevNode.graphic.setSelected(false);
    }
    if (!node) {
      this.tr.nodes([]);
    } else {
      this.prevNode = node;
      if (this.prevNode && this.prevNode.graphic) {
        this.prevNode.graphic.setSelected(true);
      }
      this.tr.nodes([node]);
    }
  }

  // 操作状态
  changeStageState(state) {
    if (state === this.state) return;
    console.log('changeStageState');
    if (state === STATE.EDIT) {

    } else {

    }
    this.state = state;
    this.editLayer.draw();
    this.option.listeners.changeStageState(state);
  }

  render() {
    this.bgLayer.batchDraw();
    this.editLayer.batchDraw();
  }

  // 区域块点击
  blockClickHandler(e, target) {
    if (e.evt.button === 0 && this.state === STATE.EDIT) {
      this.option.listeners.blockClickHandler(e, target);
      console.log(e)
      console.log(target)
      if(this.curRect) {
        this.curRect.ele.stroke('rgba(0,0,255,1)')
      }
      this.addRect = null
      this.curRect = target
      this.curRect.ele.stroke('red')
    }
  }

  // 加载图形
  loadGraphics(data) {
    this.editLayer.removeChildren()
    console.log(data)
    this.graphicList = []
    if (data && data.length > 0) {
      data.forEach(e => {
        const rect = new Rect({
          width: e.width,
          height: e.height,
          x: e.x,
          y: e.y,
          mosaic: e.mosaic,
        }, this);
        if(this.state !== STATE.EDIT) {
          rect.ele.draggable(false)
        }
        this.graphicList.push(rect)
      })
    }
    console.log(this.graphicList)
    this.editLayer.draw()
  }

  // 更新数据
  updateGraphic(target) {
    if (!target.id) return;
    console.log(this.graphicList)
    const graphic = this.graphicList.find(g => g.id === target.id);
    if (!graphic) return;
    graphic.update(target);
    this.render();
  }

  // 视图变化
  change() {
    this.option.listeners.change()
  }

  // 删除
  deleteGraphic(id) {
    this.graphicList.forEach(g => {
      if (g.ele.id() === id) {
        g.ele.destroy();
        const gIndex = this.graphicList.findIndex(l => l.ele.id() === id);
        this.graphicList.splice(gIndex, 1);
      }
    })
    this.change()
    console.log(this.graphicList)
  }

  // 数据输出
  exportData() {
    const graphic_list = [];
    this.graphicList.forEach(g => {
      graphic_list.push(g.option)
    })
    return _.cloneDeep({
      graphic_list,
    });
  }
}
